import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { SCREENS } from '../../../constants/screens';
import { Table } from '../../components/Table/Table';
import CategoriesScreen from './screens/CategoriesScreen/CategoriesScreen';
import CategoriesEdit from './screens/CategoriesScreen/containers/CategoriesEdit/CategoriesEdit';
import ExclusionsEdit from './screens/ExclusionsScreen/containers/ExclusionsEdit/ExclusionsEdit';
import ExclusionsScreen from './screens/ExclusionsScreen/ExclusionsScreen';
import ItemsEdit from './screens/ItemsScreen/containers/ItemsEdit/ItemsEdit';
import ItemsScreen from './screens/ItemsScreen/ItemsScreen';
import MealsEdit from './screens/MealsScreen/containers/MealsEdit/MealsEdit';
import MealsScreen from './screens/MealsScreen/MealsScreen';
import MenuGroupEditScreen from './screens/MenuGroupEditScreen/MenuGroupEditScreen';
import MenuGroupsScreen from './screens/MenuGroupsScreen/MenuGroupsScreen';
import ModifiersEdit from './screens/ModifiersScreen/containers/ModifiersEdit/ModifiersEdit';
import ModifiersScreen from './screens/ModifiersScreen/ModifiersScreen';
import ItemManagementScreen from './screens/ItemManagementScreen/ItemManagementScreen';
import MenuGroupImprovementScreen from './screens/MenuGroupImprovementScreen/MenuGroupImprovementScreen';
import CustomRoute from 'src/view/components/CustomRoute/CustomRoute';
import { appStore } from 'src/mobx/appStore';
import { POS_SYSTEM_ID } from 'src/constants/integrations';
import ScreenHeader from '~/view/containers/Headers/containers/ScreenHeader/ScreenHeader';
import { localeStore } from '~/mobx/localesStore';
import { userStore } from '~/mobx/userStore';

export default class MenuManagementScreen extends React.Component<{}, {}> {
  render() {
    if (appStore.settings?.is_deliverect_client && appStore.settings?.is_branch_profiles_locked && !userStore.user.service_user) {
      return (
        <Table>
          <ScreenHeader title="txt_menu" options={[]} />
          <p>{localeStore.t('deliverect_update_menu_via_provider')}</p>
        </Table>
      );
    }

    return (
      <Table>
        <Switch>
          {/* menu groups */}
          <Route exact path={SCREENS.MENU_GROUPS()} component={MenuGroupsScreen} />
          <Route path={[SCREENS.MENU_GROUPS_CREATE(), SCREENS.MENU_GROUPS_EDIT(':id')]} component={MenuGroupEditScreen} />
          <Route path={[SCREENS.MENU_GROUP_IMPROVEMENT()]} component={MenuGroupImprovementScreen} />
          {/* categories */}
          <Route exact path={SCREENS.CATEGORIES()} component={CategoriesScreen} />
          <Route path={[SCREENS.CATEGORIES_CREATE(), SCREENS.CATEGORIES_EDIT(':id')]} component={CategoriesEdit} />
          {/* items */}
          <Route exact path={SCREENS.ITEMS()} component={ItemsScreen} />
          <Route path={SCREENS.ITEMS_CREATE()} component={ItemsEdit} />
          <Route
            path={[SCREENS.ITEMS_EDIT(':id'), SCREENS.ITEMS_BRANCHES_CONFIGURATION(':id'), SCREENS.ITEMS_BRANCHES_MODIFIERS(':id')]}
            component={ItemManagementScreen}
          />
          {/* modifiers */}
          <Route exact path={SCREENS.MODIFIERS()} component={ModifiersScreen} />
          <Route path={[SCREENS.MODIFIERS_CREATE(), SCREENS.MODIFIERS_EDIT(':id')]} component={ModifiersEdit} />
          {/* exclusions */}
          <Route exact path={SCREENS.EXCLUSIONS()} component={ExclusionsScreen} />
          <Route path={[SCREENS.EXCLUSIONS_CREATE(), SCREENS.EXCLUSIONS_EDIT(':id')]} component={ExclusionsEdit} />
          {/* meals */}
          <CustomRoute exact path={SCREENS.MEALS()} component={MealsScreen} access={appStore.isAddonsAvailable.meals} />
          <CustomRoute
            path={[SCREENS.MEALS_CREATE(), SCREENS.MEALS_EDIT(':id')]}
            component={MealsEdit}
            // addon is enabled and MARN is not enabled
            access={appStore.isAddonsAvailable.meals && appStore.settings?.pos_system_id !== POS_SYSTEM_ID.MARN}
          />
        </Switch>
      </Table>
    );
  }
}
